import groupItem from '../subject_group_item';

import 'styles/components/_panels.scss';
import 'styles/components/_list-group.scss';
import './index.scss';

(function($) {
  groupItem($);
})(jQuery);
